/**
 * lodashを個別にimportして軽量化
 * TODO 本当はちゃんとtree shakingできれば不要...
 */

import assignIn from 'lodash-es/assignIn';
import cloneDeep from 'lodash-es/cloneDeep';
import forEach from 'lodash-es/forEach';
import map from 'lodash-es/map';
import reduce from 'lodash-es/reduce';
import compact from 'lodash-es/compact';
import flatten from 'lodash-es/flatten';
import head from 'lodash-es/head';
import last from 'lodash-es/last';
import find from 'lodash-es/find';
import findIndex from 'lodash-es/findIndex';
import findLastIndex from 'lodash-es/findLastIndex';
import findKey from 'lodash-es/findKey';
import filter from 'lodash-es/filter';
import shuffle from 'lodash-es/shuffle';
import chunk from 'lodash-es/chunk';
import remove from 'lodash-es/remove';
import range from 'lodash-es/range';
import trim from 'lodash-es/trim';
import sortBy from 'lodash-es/sortBy';
import pick from 'lodash-es/pick';
import sum from 'lodash-es/sum';
import uniq from 'lodash-es/uniq';
import sample from 'lodash-es/sample';
import pullAll from 'lodash-es/pullAll';

function isArray(v) {
  return Object.prototype.toString.call(v) === '[object Array]';
}

function isObject(v) {
  return typeof v === 'object' && v !== null && !isArray(v);
}

export default {
  assignIn,
  cloneDeep,
  forEach,
  map,
  reduce,
  compact,
  flatten,
  head,
  last,
  find,
  findIndex,
  findLastIndex,
  findKey,
  filter,
  shuffle,
  chunk,
  remove,
  range,
  trim,
  sortBy,
  pick,
  sum,
  uniq,
  sample,
  pullAll,
  isElement: (v) => v && !!v.querySelector,
  isString: (v) => (v && !!v.substr) || v === '',
  isArray,
  isObject,
};
